import { Box, Checkbox, Grid } from "@mui/material";
import FormSection from "../../../../common/components/functional/formSection/FormSection";
import { useTranslation } from "react-i18next";
import { Union } from "../unionsApi";
import { StyledTextField } from "../unionsStyles";

interface Props {
  union: Union;
  setUnion: (union: Union) => void;
}

const UnionBankAccount = ({ union, setUnion }: Props) => {
  const { t } = useTranslation();

  return (
    <FormSection title={t("settings:unionBankAccount")}>
      {union?.parentId && (
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            marginLeft: "20px",
          }}
        >
          <Box sx={{ whiteSpace: "nowrap", display: "flex" }}>
            {t("settings:overrideBankAccount")}
          </Box>
          <Checkbox
            checked={union?.bankAccount?.overrideBankAccount ?? false}
            onClick={() =>
              setUnion({
                ...union,
                bankAccount: {
                  ...(union.bankAccount || {
                    iban: "",
                    bic: "",
                    overrideBankAccount: false,
                  }),
                  overrideBankAccount: !union.bankAccount?.overrideBankAccount,
                },
              })
            }
          />
        </Box>
      )}
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:iban")}
          </Box>
        </Grid>

        <Grid item xs={8}>
          <StyledTextField
            disabled={union?.bankAccount?.overrideBankAccount === false}
            value={union?.bankAccount?.iban || ""}
            name="iban"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.value.length <= 34 && // Max 34 characters
              setUnion({
                ...union,
                bankAccount: { ...union.bankAccount, iban: e.target.value },
              })
            }
          />
        </Grid>
        <Grid item xs={4}>
          <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
            {t("settings:bic")}
          </Box>
        </Grid>
        <Grid item xs={8}>
          <StyledTextField
            disabled={union?.bankAccount?.overrideBankAccount === false}
            value={union?.bankAccount?.bic || ""}
            name="bic"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
              e.target.value.length <= 11 && // Max 11 characters
              setUnion({
                ...union,
                bankAccount: { ...union.bankAccount, bic: e.target.value },
              })
            }
          />
        </Grid>
      </Grid>
    </FormSection>
  );
};

export default UnionBankAccount;
